<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p style="text-align: center;">For my daughter, Sarah</p><br/>
<p style="text-align: center;"><em>I have a small daughter called Cleis, who is like a golden flower</em></p>
<p style="text-align: center;"><em>I wouldn’t take all Croesus’ kingdom with love thrown in, for her</em></p>
<br/><br/>
<p style="text-align: right;"><em>Sappho</em></p>
<br/>
<p><em><br/>
</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?5f379a7f